import BaseQuestionModel from '../BaseQuestionModel'
import { IQuestionModelConstructor, QuestionType, SubQuestionID } from '../types'
import {
  StarRatingQuestionModelTypes,
  IStarRatingQuestionModelState,
  IStarRatingResponseValidation,
  StarRatingSubmitResponse,
  StarRatingResponse
} from './types'

const StarRatingQuestionModel: IQuestionModelConstructor<StarRatingQuestionModelTypes> = (questionSchema, action) => {
  const { model } = BaseQuestionModel<StarRatingQuestionModelTypes, IStarRatingQuestionModelState>({
    questionType: QuestionType.STAR_RATING,
    questionSchema: questionSchema,
    action,
    submitResponse,
    initState,
    validateResponse
  })
  return model
}

function submitResponse({ response, questionSchema, action }: IStarRatingQuestionModelState) {
  return response.data.reduce((acc: StarRatingSubmitResponse, item, i) => {
    if (false != action?.data?.rules?.show[item.id] && null != item.value) {
      // batch is not hidden and has a response
      // primereact stars components counts values from 1 to N, not from 0
      acc.push({ id: questionSchema.matrix_batches[i].answers[item.value - 1].id })
    }
    return acc
  }, [])
}

function initState(state: IStarRatingQuestionModelState): IStarRatingQuestionModelState {
  state.response = {
    data: state.questionSchema.matrix_batches.map<StarRatingResponse['data'][number]>(batch => {
      return { id: batch.id, value: null }
    }),
    valid: false
  }
  return state
}

function validateResponse({ response, action }: IStarRatingQuestionModelState): IStarRatingResponseValidation {
  if (!response.data.length) {
    return {
      valid: true
    }
  }

  const invalidBatches: SubQuestionID[] = []
  response.data.forEach(item => {
    if (null === item.value && false !== action?.data?.rules?.show[item.id]) invalidBatches.push(item.id)
  })

  return {
    valid: !invalidBatches.length,
    invalidBatches: invalidBatches
  }
}

export default StarRatingQuestionModel
